import React from 'react';
import { Button, Form, Grid, Confirm, Icon } from 'semantic-ui-react'
import { Field, reduxForm } from 'redux-form';
import { NameWithWhiteSpace_Regex } from 'helpers/utilCommon';
import RenderInputField from 'components/atoms/Input';
import RenderCheckbox from 'components/atoms/CheckBox';
import RenderTextArea from 'components/atoms/RenderTextarea'
import CustomColorPicker from 'components/atoms/ColorPicker'
import CustomLoader from 'components/atoms/Loader';

class AddClassificationForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isApplicableToAllCommittees: this.props.initialValues.isApplicableToAllCommittees, isConfirm: false,
            colorCode: this.props.initialValues.ColorCode,
            alertMessage: 'Update will be applicable to only those records which are not associated with this Member Classification yet.',
            colorName: this.props.initialValues.ColorName
        };
        props.pickColor(props.initialValues.ColorCode)
    }

    typeRequired = value => value && value.trim() ? undefined : this.props.requiredClassificationTypeError;
    incorrectType = value => value && !NameWithWhiteSpace_Regex.test(value) ? this.props.incorrectInputError : undefined;
    descriptionRequired = value => value ? undefined : this.props.requiredDescriptionError;
    incorrectDescription = value => value && !NameWithWhiteSpace_Regex.test(value) ? this.props.incorrectInputError : undefined;
    colorRequired = () => this.props.initialValues.ColorCode ? undefined : this.props.requiredColor;

    setApplicableToAllCommittees = (e) => {
        const self = this;
        this.setState({
            isApplicableToAllCommittees: !this.state.isApplicableToAllCommittees,
            isConfirm: false,
            alertMessage: 'Update will be applicable to only those records which are not associated with this Member Classification yet.'
        }, () => self.props.changeApplicableAll(this.state.isApplicableToAllCommittees));

    }
    oncloseAlert = () => {
        this.setState({ isConfirm: false })
    }
    onColorChange = (colorCode, colorName) => {
        let isAddedColor = this.props.colorPicker.filter(item => colorCode && item.ColorCode === colorCode).length === 0;
        this.setState({ colorCode: colorCode, colorName: colorName, error: {} }, () => this.props.pickColor(colorCode, isAddedColor, colorName))
    }
    handleForm = () => {
        let error = {}

        if (!this.state.colorCode) {
            error.message = this.props.requiredColor;
        }
        this.setState({ error: error });
        if (error && !error.message) {
            this.props.handleSubmit()
        } else {
            this.props.showLoader(false)
        }
    }
    componentDidMount() {
        let txtArea = document.getElementById('description');

        txtArea.addEventListener('keydown', () => {
            let key = window.event.keyCode;
            if (key === 13) {
                let s = txtArea.value;
                s = s.replace(/(^\s*)|(\s*$)/gi, "");
                s = s.replace(/[ ]{2,}/gi, " ");
                s = s.replace(/\n /, "\n");
                txtArea.value = s;
            }
        });


    }
    render() {

        const { submitting, isDuplicateClassification, duplicateTypeError, duplicateColorError, colorPicker, isDuplicateColor, duplicateCustomColorError, customColorNameRequired, loading } = this.props;
        const { typeRequired, incorrectType, incorrectDescription, setApplicableToAllCommittees, oncloseAlert, colorRequired, onColorChange, handleForm } = this;
        const { isApplicableToAllCommittees, colorName, colorCode, alertMessage, error } = this.state;

        return (
            <div>
                {loading && <CustomLoader />}
                <Form size='large' onSubmit={handleForm} noValidate >
                    <Grid columns='equal'>
                        <Grid.Row>
                            <Grid.Column>
                                <Field name="type" type="text" id="type"
                                    label="Classification Type" required={true}
                                    validate={[typeRequired, incorrectType]}
                                    autoFocus='true' component={RenderInputField}
                                    isDuplicate={isDuplicateClassification}
                                    duplicateError={duplicateTypeError} maxLength="30" />
                            </Grid.Column>
                            <Grid.Column>
                                <div><label class="label"><Icon name="asterisk" />Pick a color</label>
                                    <div class="customColorChooser">
                                        <div class="selectedColor ">
                                            <div id="colorPicker">
                                                <span className="colorBoxActive" style={{ 'background-color': colorCode ? colorCode : colorPicker.filter((item) => !item.IsUsed).length > 0 ? colorPicker.filter((item) => !item.IsUsed)[0].ColorCode : '#ffff' }}></span>
                                                <span className="colorNameActive">{colorName ? colorName : colorPicker.filter((item) => !item.IsUsed).length > 0 ? colorPicker.filter((item) => !item.IsUsed)[0].ColorName : ''}</span>
                                            </div>

                                        </div> {(error && error.message) && <span className="errorMessage mt0">{error.message}</span>}
                                    </div></div>

                            </Grid.Column>

                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Field name="description" type="text" id="description"
                                    label="Description"
                                    validate={[incorrectDescription]}
                                    component={RenderTextArea} maxLength="100" />
                            </Grid.Column>
                            <Grid.Column className="relative">
                                <CustomColorPicker validate={colorRequired}
                                    required='true'
                                    isDuplicate={isDuplicateColor}
                                    duplicateError={duplicateColorError}
                                    colorPicker={colorPicker}
                                    onColorChange={onColorChange}
                                    selectedColorCode={this.props.initialValues.ColorCode}
                                    selectedColorName={this.props.initialValues.ColorName}
                                    duplicateCustomError={duplicateCustomColorError}
                                    requiredCustomColorError={customColorNameRequired}
                                    {...this.props}></CustomColorPicker>

                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <label className="label"> &nbsp;</label>
                                <div className="radioWrap">
                                    <RenderCheckbox IsChecked={isApplicableToAllCommittees}
                                        IsEditable={true} className="mr10" name="isApplicableToAllCommittees"
                                        setLabeltitleProp={"Applicable to all Committees"}
                                        onchange={(event) => setApplicableToAllCommittees(event)} />
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column className="actions">
                                <Button primary type="submit" disabled={submitting}>Save</Button>
                                <Button secondary onClick={this.props.onCancel}>Cancel</Button>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                    <Confirm className="confirmBox noCancelBtn" confirmButton="Ok" content={alertMessage}
                        onCancel={oncloseAlert} onConfirm={oncloseAlert} open={this.state.isConfirm} />
                </Form >
            </div>
        );
    }
}

export default reduxForm({
    form: 'AddClassificationForm'
})(AddClassificationForm);
